export default __webpack_public_path__ + "static/digital-38c9ed5083575736a8bd7978cf33a9f5.webp";